import { User } from 'components/UsersList/UsersList';

export default function getUserName(user: User): string {
  return user?.name || user?.email;
}
